import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "has-error"
}
const _hoisted_2 = {
  key: 2,
  class: "imdex-authentication"
}
const _hoisted_3 = {
  key: 3,
  class: "reconnect-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  style: {"margin-right":"10px"},
  class: "fa fa-exclamation-triangle"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Reconnect", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "toast-container" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "tooltip-container" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { id: "pane-container" }, null, -1)
const _hoisted_9 = { class: "dialog-card" }
const _hoisted_10 = { class: "dialog-title" }
const _hoisted_11 = { class: "dialog-body" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = { style: {"float":"right"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_17 = { class: "dialog-card dialog-error" }
const _hoisted_18 = { class: "dialog-title" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" }, null, -1)
const _hoisted_20 = { class: "dialog-body" }
const _hoisted_21 = { class: "dialog-actions" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLayout = _resolveComponent("AppLayout")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("common.hasError")), 1))
      : _createCommentVNode("", true),
    (_ctx.ready && !_ctx.hasError)
      ? (_openBlock(), _createBlock(_component_AppLayout, { key: 1 }))
      : _createCommentVNode("", true),
    (!_ctx.ready && !_ctx.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_imdex_spinner, {
            color: "#aeaeae",
            size: "2",
            width: "100"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.isWsLinkDisconnectedWithState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_ctx.$t("session.disconnected")) + " ", 1),
          _createVNode(_component_imdex_btn, {
            style: {"margin-left":"10px"},
            dark: "",
            textl: "",
            onClick: _ctx.prepareLoadSaveStateFromDisconnect,
            loading: _ctx.resetLoading
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _createVNode(_component_imdex_dialog, {
      width: "850",
      dismissable: false,
      value: _ctx.eulaDialog,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eulaDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("eula.title")), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("eula.description")), 1),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                href: _ctx.agreementPdf,
                target: "_blank",
                rel: "noopener noreferrer",
                style: {"text-decoration":"none","font-weight":"bold"}
              }, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_ctx.agreementName), 1)
              ], 8, _hoisted_12)
            ]),
            _createElementVNode("iframe", {
              id: "agreement-pdf",
              src: _ctx.agreementPdf,
              frameborder: "0",
              width: "800",
              height: "500"
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_imdex_btn, {
              textl: "",
              onClick: _ctx.logout
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("session.signOut")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_imdex_btn, {
              secondary: "",
              onClick: _ctx.acceptAgreement
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("eula.accept")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _hoisted_16
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      dismissable: false,
      width: "430",
      value: _ctx.isWsLinkDisconnectedWithoutState,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isWsLinkDisconnectedWithoutState) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("session.sessionLost")), 1)
          ]),
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("session.sessionLostDescription")), 1),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_imdex_btn, {
              secondary: "",
              dark: "",
              onClick: _ctx.reset,
              loading: _ctx.resetLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("session.connectNewSession")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _hoisted_22
        ])
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}